import { GET_FAQS, GET_FAQ_DETAIL, UPDATE_FAQ, API_RESPONSE_SUCCESS, API_RESPONSE_ERROR, DELETE_FAQS, GET_SUB_FAQS } from "./actionType";

export const getFaqs = () => ({
    type: GET_FAQS
});

export const getFaqDetail = (id) => ({
    type: GET_FAQ_DETAIL,
    payload: { id }
});

export const updateFaq = (data) => ({
    type: UPDATE_FAQ,
    payload: data
});

export const faqApiResponseSuccess = (actionType, data) => ({
    type: API_RESPONSE_SUCCESS,
    payload: { actionType, data }
});

export const faqApiResponseError = (actionType, error) => ({
    type: API_RESPONSE_ERROR,
    payload: { actionType, error }
});

export const deleteFaqsAction = () => ({
    type: DELETE_FAQS
});

export const getSubFaqs = (parentId) => ({
    type: GET_SUB_FAQS,
    payload: { parentId }
}); 